var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteOutlined({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "DeleteOutlined"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.8922 4.81778H11.5708C11.7476 4.81778 11.8922 4.67314 11.8922 4.49636V4.81778H24.1065V4.49636C24.1065 4.67314 24.2512 4.81778 24.4279 4.81778H24.1065V7.71064H26.9994V4.49636C26.9994 3.07805 25.8463 1.92493 24.4279 1.92493H11.5708C10.1525 1.92493 8.99937 3.07805 8.99937 4.49636V7.71064H11.8922V4.81778ZM32.1422 7.71064H3.85652C3.14535 7.71064 2.5708 8.28519 2.5708 8.99636V10.2821C2.5708 10.4589 2.71544 10.6035 2.89223 10.6035H5.31902L6.31143 31.6169C6.37571 32.987 7.50875 34.0678 8.87884 34.0678H27.1199C28.494 34.0678 29.623 32.991 29.6873 31.6169L30.6797 10.6035H33.1065C33.2833 10.6035 33.4279 10.4589 33.4279 10.2821V8.99636C33.4279 8.28519 32.8534 7.71064 32.1422 7.71064ZM26.8105 31.1749H9.18821L8.21589 10.6035H27.7829L26.8105 31.1749Z",
    fill: "black",
    fillOpacity: 0.85
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteOutlined);
export default __webpack_public_path__ + "static/media/DeleteOutlined.fd777891d89b02476bb80e65a7848cbd.svg";
export { ForwardRef as ReactComponent };